<gdl-notifications-list
  [notifications]="all$ | async"
  (markAsReaded)="onMarkAsReaded($event)"
  (remove)="onRemove($event)"
>
</gdl-notifications-list>
